import { IMAGE_PLACEHOLDER } from '@/constants/global';
import { HugeiconsIcon } from '@hugeicons/react';
import { Settings02Icon } from '@hugeicons/core-free-icons';
import {
  Card as MuiCard,
  CardMedia,
  CardContent,
  Typography,
  CardActions,
  Stack,
  CircularProgress,
  ButtonProps,
  Button,
  IconButton,
} from '@mui/material';

interface Props {
  title: string;
  description?: string;
  image?: string;
  isLoading?: boolean;
  actions?: ButtonProps[];
  direction?: 'row' | 'column';
  style?: React.CSSProperties;
  onSettingsClick?: () => void;
}

const Card = ({
  title,
  description,
  image,
  actions,
  isLoading = false,
  direction,
  onSettingsClick,
}: Props) => {
  if (isLoading) {
    return (
      <Stack flex={1} direction="row" justifyContent="center">
        <CircularProgress />
      </Stack>
    );
  }

  return (
    <MuiCard sx={{ position: 'relative' }}>
      {onSettingsClick && (
        <IconButton
          onClick={onSettingsClick}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 1)',
            },
            zIndex: 1,
          }}
        >
          <HugeiconsIcon icon={Settings02Icon} size={16} />
        </IconButton>
      )}
      <Stack
        direction={direction}
        sx={direction === 'row' ? { display: 'flex', flex: 1 } : { flex: 1 }}
      >
        <CardMedia
          image={image || IMAGE_PLACEHOLDER}
          title={title}
          sx={
            direction === 'row'
              ? { width: 130, height: 130 }
              : { height: '140px' }
          }
        />
        <Stack
          display={'flex'}
          padding={1}
          sx={direction === 'row' ? { flex: 1 } : { flex: 'none' }}
        >
          <CardContent>
            <Typography gutterBottom variant="h3" component="div">
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          </CardContent>
          {actions && actions.length > 0 ? (
            <CardActions>
              <Stack spacing={2} direction="row" flex={1}>
                {actions.map((action, index) => (
                  <Button key={index} {...action} />
                ))}
              </Stack>
            </CardActions>
          ) : null}
        </Stack>
      </Stack>
    </MuiCard>
  );
};

export default Card;
